const primaryColor = '#2289ff';
const secondaryColor = '#999999';
const fontSize = '0.8em';
const fontSizeSmall = '0.7em';
const fontFamily = "'Helvetica Neue', helvetica, 'Lucida Sans', sans-serif";

export const signature = {
    marginTop: '2em',
    color: secondaryColor,
    fontFamily: fontFamily,
    lineHeight: '1.3em'
};

export const user = {
    fontWeight: 'bold',
    color: primaryColor
};

export const info = {
    fontWeight: 'bold'
};
export const links = {
    color: primaryColor,
    fontWeight: 'normal',
    textDecoration: 'none'
};
export const pipe = {
    fontWeight: 'bold',
    fontSize: fontSize
};

export const neosperience = {
    color: secondaryColor,
    fontWeight: 'normal',
    fontSize: fontSize,
    p: {
        fontSize: fontSizeSmall,
        marginTop: '0.8em'
    },
    a: {
        color: secondaryColor,
        textDecoration: 'none'
    },
    smallText: {
        marginTop: '0.8em',
        a: {
            textDecoration: 'underline'
        }
    },
    pipe: {
        color: secondaryColor,
        fontSize: fontSize
    }
};



// WEBPACK FOOTER //
// ./src/style.js